import { useLocation } from "react-router-dom";

import TokenService from "../jwt-token/jwt-token";

/**
 * Provides utilities whether the user is authenticated or not and the current path
 */
function useAuthentication() {
	const location = useLocation();
	const isAuthenticated = () => TokenService.getAccessToken();

	// console.log(location)

	return {
		currentPath: location.pathname,
		isAuthenticated: isAuthenticated(),
	};
}

export default useAuthentication;
